var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:send-line",
    clipPath: "url(#clip0_1119_20179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9937 4.50667L3.59904 7.542L6.3957 9.16067L8.8617 6.694C8.9868 6.569 9.15643 6.49881 9.33327 6.49887C9.51012 6.49893 9.6797 6.56924 9.8047 6.69434C9.92971 6.81943 9.9999 6.98906 9.99984 7.16591C9.99977 7.34275 9.92946 7.51233 9.80437 7.63734L7.3377 10.104L8.9577 12.9L11.9937 4.50667ZM12.209 3.01067C13.0057 2.722 13.7777 3.494 13.489 4.29067L9.9677 14.0273C9.67837 14.826 8.5877 14.9233 8.1617 14.188L6.01704 10.4827L2.3117 8.338C1.57637 7.912 1.67304 6.82134 2.47237 6.532L12.209 3.01067Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1119_20179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/invite-icon.d9bf4dff8dc0bde2aaabd00dd6b3e7e1.svg";
export { ForwardRef as ReactComponent };